import { forwardRef } from 'react';
import type { InputNumberRef } from '@rc-component/input-number';
import { NumberInput } from './NumberInput';
import type { NumberInputProps } from './NumberInput';

/**
 * Props {@link IDRInput}.
 *
 * Inherits semua props {@link NumberInput} kecuali `numberFormat`/`showControls`
 * yang sudah dikunci sesuai spek IDR.
 */
export type IDRInputProps = Omit<
  NumberInputProps,
  'numberFormat' | 'showControls'
>;

/**
 * DERIVATIF: Textbox untuk nilai uang IDR (Rupiah).
 *
 * Spek:
 * - Base: {@link NumberInput} (rata kanan, separator id-ID, 0→'', - prefix).
 * - Integer (tanpa desimal).
 * - Tidak ada stepper.
 * - **Tidak menampilkan simbol "Rp"** — simbol diletakkan di luar (label/addon)
 *   bila perlu.
 *
 * Contoh:
 * - 1500   → tampil `1.500`
 * - -1500  → tampil `-1.500`
 * - 0      → tampil `` (kosong)
 *
 * Pemakaian:
 * ```tsx
 * <IDRInput value={nominal} onChange={setNominal} />
 * ```
 *
 * Dokumentasi pattern: `.claude/docs/Booku v2/ui-patterns/textbox-pattern.md`
 */
export const IDRInput = forwardRef<InputNumberRef, IDRInputProps>(
  function IDRInput(props, ref) {
    return (
      <NumberInput
        ref={ref}
        numberFormat="integer"
        showControls={false}
        {...props}
      />
    );
  }
);
